import { httpClient } from '../utils/httpClient';
import { Seccion } from '../types/usuario.types';
import { SeccionPayload } from '../types/seccion.types';

// ============================================================
// seccionService.ts
// ============================================================

export const seccionService = {

  async listar(): Promise<Seccion[]> {
    return httpClient.get<Seccion[]>('/secciones');
  },

  async obtener(id: number): Promise<Seccion> {
    return httpClient.get<Seccion>(`/secciones/${id}`);
  },

  async crear(payload: SeccionPayload): Promise<Seccion> {
    return httpClient.post<Seccion>('/secciones', payload);
  },

  async modificar(id: number, payload: SeccionPayload): Promise<Seccion> {
    return httpClient.put<Seccion>(`/secciones/${id}`, payload);
  },

  async eliminar(id: number): Promise<void> {
    return httpClient.delete<void>(`/secciones/${id}`);
  },
};
